//GeneratorFlag:[NoChange]
import Product from './product';
import ProductSeo from './product-seo';
import Feature from './feature';

export default {Product, ProductSeo, Feature}
export{Product, ProductSeo, Feature}